export const SOLO_UID_FETCH_REQUEST = "SOLO_UID_FETCH_REQUEST";
export const SOLO_UID_FETCH_SUCCESS = "SOLO_UID_FETCH_SUCCESS";
export const SOLO_UID_FETCH_ERROR = "SOLO_UID_FETCH_ERROR";
